import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ThemeModeComponent } from '../../../kt/layout';

export type ThemeModeType = 'dark' | 'light' | 'system';
const systemMode = ThemeModeComponent.getSystemMode() as 'light' | 'dark';
const themeModeSwitchHelper = (_mode: ThemeModeType) => {
  // change background image url
  const mode = _mode !== 'system' ? _mode : systemMode;
  const imageUrl =
    './assets/media/patterns/header-bg' +
    (mode === 'light' ? '.jpg' : '-dark.png');
  document.body.style.backgroundImage = `url("${imageUrl}")`;
};

const themeModeLSKey = 'kt_theme_mode_value';
const themeMenuModeLSKey = 'kt_theme_mode_menu';

const getThemeModeFromLocalStorage = (lsKey: string): ThemeModeType => {
  // Always return 'light' to force light mode
  return 'light';
};

@Injectable({
  providedIn: 'root',
})
export class ThemeModeService {
  public mode: BehaviorSubject<ThemeModeType> =
    new BehaviorSubject<ThemeModeType>(
      getThemeModeFromLocalStorage(themeModeLSKey)
    );
  public menuMode: BehaviorSubject<ThemeModeType> =
    new BehaviorSubject<ThemeModeType>(
      getThemeModeFromLocalStorage(themeMenuModeLSKey)
    );

  constructor() {
    // Force clear any existing theme settings and set to light mode
    this.forceSetLightMode();
  }

  private forceSetLightMode() {
    if (localStorage) {
      // Clear any existing theme settings
      localStorage.setItem(themeModeLSKey, 'light');
      localStorage.setItem(themeMenuModeLSKey, 'light');
    }

    // Force document to light mode
    document.documentElement.setAttribute('data-bs-theme', 'light');

    // Update BehaviorSubjects to light mode
    this.mode.next('light');
    this.menuMode.next('light');
  }

  public updateMode(_mode: ThemeModeType) {
    // Always force light mode regardless of input
    const updatedMode = 'light';
    this.mode.next(updatedMode);
    // themeModeSwitchHelper(updatedMode)
    if (localStorage) {
      localStorage.setItem(themeModeLSKey, updatedMode);
    }

    document.documentElement.setAttribute('data-bs-theme', updatedMode);
    ThemeModeComponent.init();
  }

  public updateMenuMode(_menuMode: ThemeModeType) {
    // Always force light mode regardless of input
    this.menuMode.next('light');
    if (localStorage) {
      localStorage.setItem(themeMenuModeLSKey, 'light');
    }
  }

  public init() {
    this.updateMode(this.mode.value);
    this.updateMenuMode(this.menuMode.value);
  }

  public switchMode(_mode: ThemeModeType) {
    // Always force light mode regardless of input
    if (localStorage) {
      localStorage.setItem(themeModeLSKey, 'light');
      localStorage.setItem(themeMenuModeLSKey, 'light');
    }
    // Force document to light mode immediately
    document.documentElement.setAttribute('data-bs-theme', 'light');
    // No need to reload, just apply light mode
  }
}
